module.exports = "<h3>Quotazione cellulari usati</h3>\n<div *ngFor=\"let brand of brands\">\n  <a [routerLink]=\"['/quotazione-cellulare', brand.id]\">{{brand.name}}</a>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/fonzi-module/all-brands/all-brands.component.html
// module id = 739
// module chunks = 1